import React, { useContext, useState } from 'react'
import { Context } from '../../../Store'
import { Grid, Typography, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { ErrorMessage } from './ErrorMessage'
import { COUNTRY_NAMES_BY_CODE, ISO_3166_COUNTRIES } from '../../../constants'

export const Nationality = () => {
  const [state, dispatch] = useContext(Context)
  const [nationality, setNationality] = useState(state?.nationality)
  const { t } = useTranslation()

  const onChangeNationality = (event) => {
    dispatch({ type: 'SET_NATIONALITY', payload: event.target.value })
    setNationality(event.target.value)
  }

  return (
    <Grid item xs={12} lg={11}>
      <Typography variant="body1">{t('booking.userInfo.nationality.title')}</Typography>
      <FormControl fullWidth variant="outlined">
        <InputLabel name="nationality">{t('booking.userInfo.nationality.placeholder')}</InputLabel>
        <Select
          name="nationality"
          label={t('booking.userInfo.nationality.placeholder')}
          value={nationality}
          onChange={onChangeNationality}
          error={state?.error?.nationality}
        >
          {ISO_3166_COUNTRIES.map((value) => (
            <MenuItem key={value} value={value}>
              {value} - {COUNTRY_NAMES_BY_CODE[value]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {state?.error?.nationality && <ErrorMessage error={state?.error?.nationality} />}
    </Grid>
  )
}
